export { default } from './CountryFlag';



// WEBPACK FOOTER //
// ./src/client/js/view/components/UserForm/CountryFlag/index.js